import { SVGInstance } from "../../../browser/instance/SVGInstance.js";
import { SVGStopInstance } from "../../instances/SVGStopInstance.js";
export class GradientStopInstances extends SVGInstance {
    addStop(position, color) {
        const stop = new SVGStopInstance(this);
        stop.attr("offset", position);
        stop.attr("stop-color", color);
        this.appendInstance(stop);
        return stop;
    }
}
//# sourceMappingURL=gradientStopInstances.js.map